export const APP_CONFIG = {
  companyName: "Satya Solar",
  shortName: "Satya",
  supportEmail: "info@satyasolarsystems.com",
  supportPhone: "+91 6386663156",
  companyAddress: "2nd Floor Satya Business Park, 1 Nawal Kishore Road, Hazratganj, Lucknow-226001",
  companyAddressShort: "Satya Solar Systems Pvt Ltd",
  logoPath: "/logo.png",
  year: new Date().getFullYear(),
  trackingPrefix: "SATYA-", // Useful for generating Tracking IDs
};
